import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => {
    const token = theme.partnerComponents.customDatePicker;

    return {
    root: {
        '& .MuiFormLabel-root': {
            color: theme.palette.text.primary,
            fontSize: '14px !Important',
            fontFamily: theme.typography.inter.fontFamily,
        },
        '& .MuiInputBase-root.Mui-disabled': {
            color: 'rgba(0, 0, 0, 0.85) !important',
        },
        '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
            fontSize: '12px !Important',
            transform: 'translate(16px, -6px) scale(0.95)',
        },
        '& .MuiInputLabel-outlined': {
            backgroundColor: 'transparent!important',
        },
        '& .MuiInputBase-input': {
            color: theme.palette.text.primary,
            fontFamily: theme.typography.inter.fontFamily,
            letterSpacing: '-0.13px',
            lineHeight: '24px',
            fontSize: 14,
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderWidth: '1px',
            borderColor: token.border,
        },
        '& .MuiFormHelperText-root': {
            fontFamily: 'Inter',
        },
        '& .MuiIconButton-root': {
            color: token.icon,
        },
        '& .MuiIconButton-root svg path': {
            fill: token.icon,
        },
    },
    iconCalendar: {
        fill: token.icon,
    },
};
});
